import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { Field } from 'react-final-form';
import { useSelector } from 'react-redux';

import useWizardContext from '@swf/core/hooks/useWizardContext';
import { select } from '@swf/core/store';

import Button from '../../../Button/Button';
import ButtonGroup from '../../../ButtonGroup/ButtonGroup';
import Container from '../../../Container/Container';

import {
  TXTCLI_Cancel_Pending_Cashouts,
  TXTCLI_Pending_Cashouts,
  TXTWCL_Cancel_pending_withdrawal,
  TXTWCL_Cancelling_pending_withdrawals_ELL,
  TXTWCL_Continue_Deposit,
  TXTWCL_You_have_1_pending_withdrawal__ELL,
  TXTWCL_You_have_N0_pending_withdrawal_ELL
} from './DepositPendingCashoutMenu.messages.json';
import { button, title } from './DepositPendingCashoutMenu.scss';

const DepositPendingCashoutMenu: React.FC = () => {
  const {
    data: { pendingCashouts }
  } = useWizardContext();
  const isEmbedded = useSelector(select.device.isEmbedded);

  const singleTransaction = pendingCashouts.length === 1;

  return (
    <Container
      headerProps={{
        buttons: { back: true, exitWizardOnBackClick: true },
        title: <Translation {...TXTCLI_Pending_Cashouts} />
      }}
      page={DepositPendingCashoutMenu}
      pageTopTitle={
        !isEmbedded && (
          <span className={title}>
            <Translation {...TXTCLI_Pending_Cashouts} />
          </span>
        )
      }
      helpSupportResolver
      showFooter
    >
      <>
        <p>
          <Translation
            {...(singleTransaction
              ? TXTWCL_You_have_1_pending_withdrawal__ELL
              : TXTWCL_You_have_N0_pending_withdrawal_ELL)}
            values={{ 0: pendingCashouts.length }}
          />{' '}
          <Translation {...TXTWCL_Cancelling_pending_withdrawals_ELL} />
        </p>
        <Field name="pendingCashouts.menuSelected">
          {({ input: { onChange } }) => (
            <ButtonGroup>
              <Button
                type="submit"
                className={button}
                onClick={() => {
                  onChange('pendingCashout');
                }}
                translation={
                  singleTransaction
                    ? TXTWCL_Cancel_pending_withdrawal
                    : TXTCLI_Cancel_Pending_Cashouts
                }
              />
              <Button
                type="submit"
                className={button}
                onClick={() => {
                  onChange('deposit');
                }}
                variant="secondary"
                translation={TXTWCL_Continue_Deposit}
              />
            </ButtonGroup>
          )}
        </Field>
      </>
    </Container>
  );
};

DepositPendingCashoutMenu.displayName = 'DepositPendingCashoutMenu';

export default DepositPendingCashoutMenu;
